import { createIdSlice } from '../utils/action/createElementSlice';
export const BusyState = createIdSlice({
    elementName: 'busy',
    initialState: {},
    reducers: {
        setBusy: (_state, action) => {
            const isBusy = action.payload.data.isBusy;
            return {
                isBusy: isBusy,
                indicatorVisible: isBusy,
                canPause: action.payload.data.canPause,
            };
        },
        togglePaused: (state) => {
            if (!state)
                return;
            return Object.assign(Object.assign({}, state), { isPaused: !state.isPaused });
        },
        hideIndicator: (state) => {
            if (!state)
                return;
            return Object.assign(Object.assign({}, state), { indicatorVisible: false });
        },
    },
});
